import {
  ContentLayout,
  HeaderBreadcrumbs,
  Loader,
  NewFormCardWrapper,
  PageNotFound,
} from "../../../shared";
import React from "react";
import { Button } from "@mui/material";
import InputControl from "../../../shared/components/InputControl";

import "react-quill/dist/quill.snow.css";
import { useParams } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { useBundles } from "../hooks";
import { MultiLanguageNameTable } from "../../Category";

export const CreateOrEditBundles = () => {
  const { id } = useParams();
  const {
    state,
    onChangeInput,
    onSaveBundleGroup,
    onUpdateBundleGroup,
  } = useBundles({ isDetailsId: id, isAdd: true });
  const { updateData, isSaveButtonBusy, BundleGroupDetails } = state;
  const [, forceUpdate] = React.useState();
  const validator = React.useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      validators: {
        maxChoice: {
          message: "The Maximum Choice should greater than Minimum Choice",
          rule: (value) => {
            const { max_choice, min_choice } = value;
            return parseInt(max_choice) >= parseInt(min_choice)
          },
        },
      },
    })
  );

  const onSubmit = () => {
    if (validator.current.allValid()) {
      id ? onUpdateBundleGroup(id) : onSaveBundleGroup();
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };
  if (state.httpStatusCodes.details === 404) {
    return <PageNotFound />;
  }

  const columns = [
    {
      head: "Language",
      accessor: "lang",
      sx: { width: "20%", minWidth: "150px" },
    },
    {
      head: "Bundle Name*",
      accessor: (row, index) => {
        const bundleNameMessage = validator.current.message(
          `${row.code} Bundle Name`,
          row.locale_name,
          "required|min:3",
        );
        return (
          <InputControl
            name="locale_name"
            label=""
            value={row.locale_name}
            onChange={(e) => onChangeInput(e, index)}
            required
            error={!!bundleNameMessage}
            helperText={bundleNameMessage}
          />
        );
      },
      sx: { width: "80%" },
    },
  ];
  return (
    <>
      <ContentLayout
        title={id ? BundleGroupDetails.dataList?.name : "New Bundles"}
        rightContent={
          <>
            <Button
              type="button"
              size="medium"
              variant="contained"
              disabled={isSaveButtonBusy}
              onClick={() => onSubmit()}
            >
              {!id ? "Save" : "Update"}
            </Button>
          </>
        }
        breadcrumbs={
          <HeaderBreadcrumbs
            links={[
              { name: "Dashboard", href: "/" },
              { name: "Bundle Groups", href: "/bundle" },
              id ? {
                name: BundleGroupDetails.dataList?.name,
                href: `/bundle/details/${id}`,
              } : null,
              { name: id ? "Edit" : "Create" },
            ].filter(Boolean)}
          />
        }
      >
        {id && BundleGroupDetails.isLoading ? (
          <Loader />
        ) : (
          <NewFormCardWrapper title="Details">
            <MultiLanguageNameTable
              columns={columns}
              data={state.bundleNamings}
              loading={state.bundleNamingsLoading}
            />
            <InputControl
              name="alias"
              label="Alias"
              autoComplete="off"
              onChange={onChangeInput}
              value={updateData.alias}
              required
              error={validator.current.message(
                "Alias",
                updateData.alias,
                "required",
              )}
              helperText={validator.current.message(
                "Alias",
                updateData.alias,
                "required",
              )}
              sx={{
                mt: "8px",
              }}
              inputProps={{
                style: {
                  background: "#ffffff",
                },
              }}
            />
          </NewFormCardWrapper>
        )}
      </ContentLayout>
    </>
  );
};
